module.exports = __webpack_public_path__ + "static/play-fa691fca179c9ba4e0d764bd0e67c5aa.png";